export default __webpack_public_path__ + "static/media/2023.cd599398.jpg";